import React, {useCallback, useEffect, useState} from 'react';
import {Button} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles.js";
import Checkbox from "@material-ui/core/Checkbox";
import { DynamicFields } from '../../utils/dynamicFields';
import { DataGrid } from '@material-ui/data-grid';
import { Dialog } from '../Dialog/Dialog';


const CheckListFillDialog = (props) => {

    const {open, onClose, offenseWindow, initialValues, value, setFieldValue, variable, id, idChapter} = props

    const [rows, setRows] = useState(null)
    const [columns, setColumns] = useState(null)
    
    const howComponent = (el) => {
        if (el.type === 'checkbox-field') 
            return false
        else return ''
    } 
    
    const handleRowChange = (params) => {
        let getRows = [...rows]
        let newRows = []
        getRows.map(row => {
                if (row.id === params.id) {
                    let newRow = row
                    newRow[params.field] = params.value
                    newRows.push(newRow)
                } else newRows.push(row)
        })
        setRows(newRows)
        
    }

    const handleRowChangeCheckBox = (params, chlen) => {
        let getRows = [...chlen]
        if (getRows.length !== 0) {
            let newRows = []
            getRows.map(row => {
                if (row.id === params.id) {
                    let newRow = row
                    newRow[params.field] = !params.value
                    newRows.push(newRow)
                } else newRows.push(row)
            })
            setRows(newRows)
        }  
    }

    const getValue = (id) => {
        let stroke = []
        let column = {}
      
        offenseWindow.map((el) => {
            column = {...column, ...{[el.variable]: howComponent(el)}}
        })

       

        if (typeof value !== 'object' ) { 

                    initialValues.map((article) => {
                        let number = article.number.replace('_','')
                        let goodRow = {
                                id: number,
                                name: article.full_text,
                                ...column
                        }
                        stroke.push(goodRow)
                    })
                        return stroke
                    } else  {
        
                    let flag = false
                    let fakeRows = []
        
                    value.map((el) => {
                            for (const key in el) {
                                if (key === id) {
                                    flag = true
                                    fakeRows = [...el[key]]
                                }
                            }
        
                    })
        
                    if (flag) {
                    
                        return fakeRows
                    } else  {
                        initialValues.map((article) => {
                            let number = article.number.replace('_','')
                            let goodRow = {
                                    id: number,
                                    name: article.full_text,
                                    ...column
                            }
        
                            stroke.push(goodRow)
        
                            })
                
                        return stroke    
                    }
            }
        
    }

    const howColumn = (el, stroke) => {
     
        switch (el.type) {
            case DynamicFields.BASE_SELECT: 
                return (
                    {     
                        field: el.variable, 
                        headerName: el.label, 
                        width: 140,
                        editable: true,
                        content: el.content,
                        helperText: el.helperText,
                        id: el.id,
                        label: el.label,
                        sequenceNumber: el.sequenceNumber,
                        variable: el.variable,
                        type: "singleSelect",
                        valueOptions: el.content.choices.map(choice => choice.value)
                    }
                )
            case DynamicFields.CHECKBOX_FIELD: 
                return (
                    {     
                        field: el.variable, 
                        headerName: el.label, 
                        width: 140,
                        editable: false,
                        content: el.content,
                        helperText: el.helperText,
                        id: el.id,
                        label: el.label,
                        sequenceNumber: el.sequenceNumber,
                        variable: el.variable,
                        renderCell: (params) => (
                            <Checkbox checked={params.value} onClick={() => handleRowChangeCheckBox(params, stroke)} />
                        )
                    }
                )
            default: 
                return (
                    {
                        field: el.variable, 
                        headerName: el.label, 
                        width: 300,
                        editable: true,
                        helperText: el.helperText,
                        id: el.id,
                        label: el.label,
                        sequenceNumber: el.sequenceNumber,
                        variable: el.variable,
                    }
                )
        }
    }

    const getColumnsOffenseWindows = (poles, stroke) => {
        let propsColumns = []
        if (poles) {
            poles.map((el) => {
                const column = howColumn(el, stroke)
                propsColumns.push(column)
             })
        }

        const columns = [...[
             { field: 'id', 
               headerName: 'Пункт', 
               width: 140,
               editable: true,
             },
             { 
               field: 'name', 
               headerName: 'Название', 
               width: 300,
               editable: true,
             },
             
           ], ...propsColumns];
        
        setColumns(columns)

    }

    useEffect (() => {

        const stroke = getValue(id)
        setRows(stroke)
        getColumnsOffenseWindows(offenseWindow, stroke)
    
        },[initialValues, offenseWindow])
 
    const handleCloseDialog = () => {
        onClose()
    }

    

    const handleSubmit = (id) => {
        const newRows = [...rows]
        const chapterID = id

        const newEl = { [chapterID] : newRows}
        const newElList = [newEl]
        const testValue = [...value]
        let flag = false

        if (testValue.length === 0 ) {
            flag = true
            setFieldValue(variable, [newEl])
            handleCloseDialog()
        } else {
            testValue.map((el, index) => {
                for (const key in el) {
                    if (key === id) {
                        let newChapter = [...testValue]
                        newChapter[index] = newEl
                        setFieldValue(variable, newChapter)
                        flag = true
                        handleCloseDialog()
                    }
                }
            })
        }

        if (!flag) {
            setFieldValue(variable, [...value, ...newElList])
            handleCloseDialog()
        }
    }

    return (
        <Dialog
            open={open}
            handleClose={handleCloseDialog}
            title={idChapter.length !== 0 &&  idChapter[0].name}
            actions={<Button onClick={() => handleSubmit(id)}>Сохранить</Button>}
            maxWidth={"lg"} 
            fullWidth={true}
        >
            {
                rows !== null && columns !== null && 
                    <div style={{ height: 700, width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns }
                            pageSize={[25]}
                            onCellEditCommit={handleRowChange}
                        />
                    </div>
                }

        </Dialog>
    );
};

export default CheckListFillDialog;



